<script lang="ts">
    import type {Loan} from 'typings/portaro.be.types';
    import {getDateFormatter, getLocalization} from 'core/svelte-context/context';
    import {exists} from 'shared/utils/custom-utils';
    import {pipe} from 'core/utils';
    import {Kind} from 'shared/constants/portaro.constants';
    import Label from 'shared/components/label/Label.svelte';

    export let value: Loan;
    export let isSelected = false;

    const localize = getLocalization();
    const dateFormatter = getDateFormatter();

    let hasExemplar: boolean;
    $: hasExemplar = exists(value.exemplar);
</script>

<template>
    <div class="panel panel-default" class:panel-success={hasExemplar} class:panel-danger={!hasExemplar}>
        <div class="panel-heading">
            <span>
                <span>{value.exemplar?.designation}</span>
                -
                <span data-qa="exemplar-document-name">{value.document.name}</span>
            </span>

            {#if isSelected}
                <span>{localize(/* @kp-localization commons.Selected */ 'commons.Selected')}</span>
            {/if}
        </div>
        <div class="panel-body">
            <div>
                {localize(/* @kp-localization user.Reader */ 'user.Reader')}
                <Label labeled={value.user} explicitKind={Kind.KIND_USER}/>
            </div>

            <div>
                {localize(/* @kp-localization loan.DatumVypujceni */ 'loan.DatumVypujceni')}
                <span class="lend-date">{pipe(value.lendDate, dateFormatter('d.M.yyyy'))}</span>
            </div>

            <div>
                {localize(/* @kp-localization loan.TerminVraceni */ 'loan.TerminVraceni')}
                <strong class:text-success={!value.expiredLoan} class:text-danger={value.expiredLoan}>
                    <span class="due-date">{pipe(value.dueDate, dateFormatter('d.M.yyyy'))}</span>
                    {#if value.expiredLoan}
                        <span>{localize(/* @kp-localization loan.ExpiredLoan */ 'loan.ExpiredLoan')}</span>
                    {/if}
                </strong>
            </div>
        </div>
    </div>
</template>

<style lang="less">
    .panel-heading {
        display: flex;
        justify-content: space-between;
    }
</style>